if (!customElements.get("card-media-slider")) {
    customElements.define(
        "card-media-slider",
        class CardMediaSlider extends HTMLElement {
            async connectedCallback() {
                if (this.swiper) return;

                const container = this.querySelector("[data-card-media-slider-container]");
                if (!container) return;

                const slides = this.querySelectorAll("[data-card-media-slider-slide]");
                if (slides.length < 2) return;

                const { default: Swiper } = await import(
                    "./swiper-bundle.esm.browser.min.js"
                );

                const paginationEl = this.querySelector(
                    "[data-card-media-slider-pagination]",
                );

                this.swiper = new Swiper(container, {
                    wrapperClass: "card__media-slider-wrapper",
                    slideClass: "card__media-slider-slide",
                    speed: 400,
                    autoplay: {
                        delay: "1000",
                    },
                    loop: true,
                    watchOverflow: true,
                    pagination: paginationEl
                        ? {
                            el: paginationEl,
                            clickable: true,
                            bulletClass: "card__media-slider-bullet",
                            bulletActiveClass: "card__media-slider-bullet--active",
                        }
                        : false,
                });
                // Stop autoplay initially
                this.swiper.autoplay.stop();

                // Play only this card's slider on hover
                this.addEventListener("mouseenter", () => {
                    this.swiper?.autoplay.start();
                });

                // Stop only this card's slider when mouse leaves
                this.addEventListener("mouseleave", () => {
                    this.swiper?.autoplay.stop();
                });
            }

            disconnectedCallback() {
                this.swiper?.destroy();
                this.swiper = null;
            }
        },
    );
}